import path from '@/api/index'
import { axios } from '@/utils/request'

// 交大登录
export function jdLogin (data) {
  return axios({
    url: path.mobile + '/loginJd',
    method: 'POST',
    params: data
  })
}
